export default /* glsl */`
#define MATCAP

varying vec3 vViewPosition;

#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <time_pars_common>

#include <clipping_planes_pars_vertex>

void main() {

#include <uv_vertex>
#include <color_vertex>
#include <beginnormal_vertex>
#include <defaultnormal_vertex>
#include <normal_vertex>

#include <begin_vertex>

if (transformed.x > 0.0) {
    float amp = 0.5;
    float periodX = 2.1;
    float frontX = 1.1;
    float speed = -3.;
    float fixingFactor = 0.0;

    if (transformed.x < frontX) {
        float x = transformed.x;
        fixingFactor = (x - frontX) * (x - frontX) / (frontX * frontX);
    }

    transformed.z += sin(transformed.x * periodX + time * speed) * amp * (1.0 - fixingFactor);
}

#include <project_vertex>

#include <clipping_planes_vertex>
#include <fog_vertex>

vViewPosition = - mvPosition.xyz;

}
`;
